module.exports = __webpack_public_path__ + "img/fundermax-slider-2.9fd78f23.jpg";